/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  Typography,
} from '@mui/material'
import { ClientStudentInstance } from 'common/utils/types/account-types-client'
import PeopleIcon from 'assets/teacher/persons.svg'
import PencilIcon from 'assets/teacher/pencil.svg'

import { DEFAULT_PROGRAM_SETTINGS, PROGRAM_LENGTHS } from '../constants'

function Confirmation({
  selectedStudents,
  selectedProgram,
}: {
  selectedStudents: ClientStudentInstance[]
  selectedProgram: typeof DEFAULT_PROGRAM_SETTINGS
}) {
  return (
    <Box>
      <Typography variant='h5'>Confirmation Summary</Typography>
      <Typography variant='body2'>
        Build the right program for your students’ learning goals. All their
        current progress will stay saved, nothing will be deleted.
      </Typography>
      <Card sx={{ mt: 4, border: '1px solid', borderColor: 'divider' }}>
        <CardHeader
          avatar={
            <Avatar sx={{ backgroundColor: 'secondary.main' }}>
              <Box component='img' src={PeopleIcon} />
            </Avatar>
          }
          title='Students Selected'
        />
        <CardContent>
          <Typography variant='body1'>
            {selectedStudents.map((student) => student.displayName).join(', ')}
          </Typography>
        </CardContent>
      </Card>
      <Box sx={{ mt: 1 }}>
        <Card sx={{ border: '1px solid', borderColor: 'divider' }}>
          <CardHeader
            avatar={
              <Avatar sx={{ backgroundColor: 'secondary.main' }}>
                <Box component='img' src={PencilIcon} />
              </Avatar>
            }
            title='Program assigned'
          />
          <CardContent>
            <List component='ul' sx={{ listStyleType: 'disc', pl: 2, py: 0 }}>
              <ListItem component='li' sx={{ display: 'list-item', pl: 0 }}>
                <Typography
                  variant='body1'
                  sx={{ textTransform: 'capitalize' }}
                >
                  Operation:{' '}
                  {Object.keys(selectedProgram.operation)
                    .filter((op) => selectedProgram.operation[op])
                    .map((op) => op.charAt(0).toUpperCase() + op.slice(1))
                    .join(', ')}
                </Typography>
              </ListItem>
              <ListItem component='li' sx={{ display: 'list-item', pl: 0 }}>
                <Typography variant='body1'>
                  Timer Threshold: {selectedProgram.timerThreshold}s
                </Typography>
              </ListItem>
              <ListItem component='li' sx={{ display: 'list-item', pl: 0 }}>
                <Typography
                  variant='body1'
                  sx={{ textTransform: 'capitalize' }}
                >
                  Difficulty Level: {selectedProgram.difficultyLevel}
                </Typography>
              </ListItem>
              <ListItem component='li' sx={{ display: 'list-item', pl: 0 }}>
                <Typography variant='body1'>
                  Program Length:{' '}
                  {PROGRAM_LENGTHS[selectedProgram.programLength]}
                </Typography>
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
}

export default Confirmation
